import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { RohstoffbilanzDetail } from '../data/detail';
import { SOFTLINE_API_ROHSTOFFBILANZ_QUERY_DETAIL } from '../rohstoffbilanz.api';

@Injectable()
export class RohstoffbilanzDetailRepository extends ReadonlyHttpApiListRepository<
  Result<RohstoffbilanzDetail[]>,
  Dictionary<unknown> | undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ROHSTOFFBILANZ_QUERY_DETAIL);
  }

  protected override getLoadPayload(
    params: Dictionary<unknown> | undefined
  ): Dictionary<unknown> | undefined {
    return params;
  }
}
